/**
 * Measura metraj kutusunu "Sepete Ekle" butonunun yanına taşır.
 *
 * Measura (sell-by-weight/length) uygulaması, metraj seçim kutusunu ürün
 * formunun ÜSTÜNDE ayrı bir app-block olarak render ediyor. Müşteri deneyimi
 * için bu kutuyu, ürün formunun içindeki "Sepete Ekle" butonunun hemen soluna
 * taşıyıp ikisini tek satırda gösteriyoruz.
 *
 * - Sepete Ekle butonu form içinde kalır (submit/loading davranışı bozulmaz);
 *   yalnızca measura kutusu (kendi başına çalışan app-block) taşınır.
 * - Idempotent: kutu zaten yerindeyse hiçbir şey yapmaz.
 * - Savunmacı: measura yoksa (o şablonda block yoksa) sessizce çıkar.
 */
(function () {
  'use strict';

  var MEASURA_SELECTOR = '.shopify-app-block[id*="measura"]';
  var placed = false;

  function place() {
    var formButtons = document.querySelector('product-form-component .product-form-buttons');
    if (!formButtons) return false;

    var measura = document.querySelector(MEASURA_SELECTOR);
    var addBtn = formButtons.querySelector('.add-to-cart-button');
    if (!measura || !addBtn) return false;

    // Zaten form içine taşınmışsa tekrar taşıma.
    if (formButtons.contains(measura)) {
      placed = true;
      return true;
    }

    var addSpan = addBtn.closest('span') || addBtn.parentElement;
    if (!addSpan || addSpan.parentElement !== formButtons) return false;

    measura.classList.add('measura-inline-box');
    formButtons.classList.add('product-form-buttons--measura-inline');
    formButtons.insertBefore(measura, addSpan);

    placed = true;
    return true;
  }

  function init() {
    if (place()) return;

    // measura app-block'u geç enjekte edilirse ya da bir bölüm yeniden
    // render edilirse yakalamak için, ürün bölümüne dar kapsamlı ve kendini
    // kapatan bir gözlemci kur (INP için hafif tutulur).
    var section =
      document.querySelector('product-form-component')?.closest('.shopify-section') ||
      document.body;

    var observer = new MutationObserver(function () {
      if (place()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });

    // Güvenlik: 10 sn sonra gözlemciyi kapat.
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Tema editöründe bölüm yeniden yüklenince tekrar dene.
  document.addEventListener('shopify:section:load', function () {
    placed = false;
    init();
  });
})();
